import actions from '../action/buyer'
import CONSTANT from '../constant/buyer'
import Vue from 'vue'
import _ from 'underscore'
export default {
    actions,
    state: {
        buyerShowBrief: [],
        buyerInfo: [],
        buyerShowDetail: [],
        buyerShowList: {},
        indexList: []
    },
    mutations: {
        [CONSTANT.BUYER_SHOW_BRIEF_SUCCESS](state, data) {
            state.buyerShowBrief.push(data)
        },
        [CONSTANT.BUYER_SHOW_BRIEF_ERROR](state, e) {
            return
        },
        [CONSTANT.BUYER_INFO_SUCCESS](state, data) {
            return state.buyerInfo.push(data)
        },
        [CONSTANT.BUYER_INFO_ERROR](state, e) {
            return
        },
        [CONSTANT.BUYER_SHOW_DETAIL_SUCCESS](state, data) {
            return state.buyerShowDetail.push(data)
        },
        [CONSTANT.BUYER_SHOW_DETAIL_ERROR](state, e) {
            return
        },
        [CONSTANT.BUYER_SHOW_LIST_SUCCESS](state, data) {
            const obj = state.buyerShowList
            let list = []
            if (data.id === obj.id && data.page != 1) {
                state.buyerShowList.list = obj.list.concat(data.list)
                _.each(obj.list, v => {
                    list.push(1)
                })
                state.indexList = list
                return
            }
            state.buyerShowList = data
            _.each(data.list, v => {
                list.push(1)
            })
            state.indexList = list
            return
        },
        [CONSTANT.BUYER_SHOW_LIST_ERROR](state, e) {
            return
        },
        changeSwipeIndex(state, data) {
            Vue.set(state.indexList, data.listIndex, data.swipeIndex)
            return
        }
    }
}